module.exports = __webpack_public_path__ + "img/slide-3-mobile-min.3959f06f.jpg";